<template>
  <div>
    <h3>Budgets & deadlines per Programme Part</h3>
    <p>Get a sense of how much funding is available for different work areas, and how it's distributed over the lifetime of Horizon Europe.</p>
    <v-chart v-if="this.horizonBubbles" class="chart" :option="options" v-on:click="triggerSearch" ref="bubbles" autoresize />

  </div>
</template>

<script>
import {
  use
} from "echarts/core";
import {
  CanvasRenderer
} from "echarts/renderers";
import {
  ScatterChart
} from "echarts/charts";

import {
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  DatasetComponent
} from "echarts/components";

import VChart, {
  THEME_KEY
} from "vue-echarts";

use([
  CanvasRenderer,
  ScatterChart,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  DatasetComponent
]);

var sizeFactor;
var COLORS = ['#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#5470c6'];

export default {
  name: 'InfoGraphicsBubbles',
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  computed: {
    horizonBubbles () {
      return this.$store.state.horizonBubbles;
    },
    options () {
      if( this.$store.state.horizonBubbles ) {
        chartOptions.dataset.source = this.horizonBubbles.data;
        sizeFactor = 80.0 / (this.horizonBubbles.meta.maxBudget -         this.horizonBubbles.meta.minBudget);
        return chartOptions;
      }
      return null;
    }
  },
  created: function () {
  //  if( this.horizonBubbles == null || this.horizonBubbles == '' ) {
      this.$store.dispatch('fetchHorizonBubbles');
  //  }
  },
  data() {
    return {
    }
  },
  methods: {
    triggerSearch: function(e) {
      if( e.data[5] ) {
        this.$router.push({path: '/'+ e.data[5] });
      }
    },

  },
}


var chartOptions = {
        tooltip: {
          position: 'bottom',
          formatter: function(params) {
            var budgetInMio = params.value[3] / 1000000;
            var listTopics = '';
            for (var topicId in params.value[4]) {
              if (topicId <= 10){
                listTopics = listTopics + '<br>' + params.value[4][topicId];
              } else if (topicId == 11){
                listTopics = listTopics + '<br>       ...'
              } else {
                continue;
              }
            }
            return '<div style="max-width:380px;white-space: break-spaces;"><b>'
            + Math.round(budgetInMio) + ' Mio. in ' +  params.value[0] +
            '</b> <br>List of Topics (' + params.value[4].length + '):'
            + listTopics +'</div>';
          }
        },
        dataset: {
          source: []
        },
        xAxis: {
          type: 'time',
          axisLine: {
            show: true
          },
          axisTick: {
            show:true
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            inside: true,
            verticalAlign: 'bottom',
            lineHeight: 100,
            fontWeight: 'bold'
          }
        },
        grid: {
          left: 10,
          bottom:10,
          right: 10,
          containLabel: true
        },

        series: [{
            type: 'scatter',
            encode: {
              x: ['Date'],
              y: ['Category']
            },
            itemStyle: {
              color: function(val) {
                return COLORS[val.value[2]];
              }
            },

            symbolSize: function(val) {
              var size = val[3] * sizeFactor;
              if( size < 4 ) return 4;
              return size;
            },

          },


        ]
      }
</script>

<style scoped>
  .chart {
    width: 95%;
    height: 600px;
  }
</style>
